<template>
  <v-row class="pa-2">
    <v-col cols="12">
      <v-row v-if="impersonationAlert">
        <v-col cols="12">
          <v-alert
            type="warning"
            v-model="impersonationAlert"
            closable
            class="banner-close-icon"
            density="compact"
            variant="outlined"
          >
            You're currently impersonating: {{ impersonatedAgent }}
          </v-alert>
        </v-col>
      </v-row>

      <v-row>
        <router-view name="default" lazy></router-view>
        <router-view name="view" lazy></router-view>
      </v-row>
      <v-row>
        <ImpersonationDialog
          v-if="impersonationDialog"
          :dialog.sync="impersonationDialog"
          :dialogType="impersonateDialogType"
          :brokerageName.sync="impersonatedAgent"
          @cancel="impersonateCancel"
          @disable="disableImpersonation"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script setup>
/*****************************
 * Imports
 ****************************/
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { defineAsyncComponent } from "vue";

/*****************************
 * Lazy/Async components
 ****************************/
const ImpersonationDialog = defineAsyncComponent(
  () => import("@/components/console/dialog/ImpersonationDialog.vue"),
);

/****************************
 * Local/'Use' Variables
 ***************************/
const store = useStore();
const router = useRouter();

/****************************
 * Ref/UI Variables
 ***************************/
const impersonationAlert = ref(false);
const impersonationDialog = ref(false);
const impersonateDialogType = ref("disableImpersonate");

/****************************
 * Emit Definitions
 ***************************/
// emits defined here

/****************************
 * Component Props
 ***************************/
// props defined here

/****************************
 * Computed Properties
 ***************************/
const impBrokerage = computed(() => store.getters["auth/impBrokerage"]);

const impersonatedAgent = computed(() => {
  return impBrokerage.value ? impBrokerage.value.name : "";
});

/****************************
 * Exposed/Interface Functions
 ***************************/
// exposed/interface functions here

/****************************
 * UI Functions
 ***************************/
const impersonateCancel = () => {
  console.log("impersonateCancel");
  impersonationAlert.value = true;
  impersonationDialog.value = false;
};

const disableImpersonation = () => {
  store.dispatch("auth/clearImpersonate").then(() => {
    impersonationDialog.value = false;
    router.push("/console/brokerages");
  });
};

/***************************
 * Watched properties
 **************************/
watch(impersonationAlert, (n) => {
  if (n === false) {
    console.log("impersonationAlert marketplace");
    impersonationDialog.value = true;
  } else {
    console.log("impersonationAlert marketplace else");
  }
});
/****************************
 * View Lifecycle Methods
 ***************************/

onMounted(() => {
  console.log("On mounted");
  impersonationAlert.value = false;
  if (impBrokerage.value) {
    console.log("On mounted 1");

    impersonationAlert.value = true;
  }
  console.log("On mounted 2");
});
</script>

<style lang="scss" scoped>
.banner-close-icon :deep(.v-btn .v-icon) {
  font-size: 20px !important;
}
.v-alert :deep(.v-icon) {
  font-size: 22px !important;
  margin-top: 6px;
}
</style>
